import type { IconProps } from './../../models/icon';

export function PercentageIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M5.14265 9.42861C7.50958 9.42861 9.42836 7.50982 9.42836 5.14289C9.42836 2.77596 7.50958 0.857178 5.14265 0.857178C2.77572 0.857178 0.856934 2.77596 0.856934 5.14289C0.856934 7.50982 2.77572 9.42861 5.14265 9.42861Z"
        />
        <path
          fill={secondaryColor}
          d="M18.857 23.1428C21.2239 23.1428 23.1427 21.224 23.1427 18.8571C23.1427 16.4902 21.2239 14.5714 18.857 14.5714C16.4901 14.5714 14.5713 16.4902 14.5713 18.8571C14.5713 21.224 16.4901 23.1428 18.857 23.1428Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M5.14265 9.42861C7.50958 9.42861 9.42836 7.50982 9.42836 5.14289C9.42836 2.77596 7.50958 0.857178 5.14265 0.857178C2.77572 0.857178 0.856934 2.77596 0.856934 5.14289C0.856934 7.50982 2.77572 9.42861 5.14265 9.42861Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M18.857 23.1428C21.2239 23.1428 23.1427 21.224 23.1427 18.8571C23.1427 16.4902 21.2239 14.5714 18.857 14.5714C16.4901 14.5714 14.5713 16.4902 14.5713 18.8571C14.5713 21.224 16.4901 23.1428 18.857 23.1428Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M0.856934 23.1429L23.1426 0.857178"
        />
      </g>
    </svg>
  );
}
